new Vue({
    el: '#app',
    methods: {
        showNewsletterModal() {
            window._header.showNewsletterModal();
        }
    },
})
